import { render, staticRenderFns } from "./caseheader.vue?vue&type=template&id=9268f73e&scoped=true"
import script from "./caseheader.vue?vue&type=script&lang=js"
export * from "./caseheader.vue?vue&type=script&lang=js"
import style0 from "./caseheader.vue?vue&type=style&index=0&id=9268f73e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9268f73e",
  null
  
)

export default component.exports